<div class="msg-dialog" [ngClass]="'msg-dialog--' + type">
  <div class="msg-dialog__icon" ngbAutofocus>
    @switch (type) {
      @case ("success") {
        <i class="bi bi-check-lg"></i>
      }
      @case ("error") {
        <i class="bi bi-x-lg"></i>
      }
      @case ("warning") {
        <i class="bi bi-exclamation-lg"></i>
      }
      @case ("info") {
        <i class="bi bi-info-lg"></i>
      }
      @default {
        <i class="bi bi-info-lg"></i>
      }
    }
  </div>

  @if (title) {
    <h4 class="msg-dialog__title">{{ title }}</h4>
  }
  <p class="msg-dialog__content">{{ content }}</p>

  <button type="button" class="btn msg-dialog__btn" (click)="close()">
    {{ confirmButtonMsg }}
  </button>
</div>
